import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth.js";

/**
 * Protege rutas admin-only: técnico autenticado → redirige a la home.
 *
 * SECURITY (TOG-01): This guard ALWAYS checks the real JWT `rol` claim from
 * the auth context. It intentionally does NOT consult the view-as overlay —
 * the overlay is a pure rendering/routing hint for admitted admin users; it
 * never changes what routes a technician can access. A technician MUST NOT
 * reach /admin by activating a viewAs override.
 */
export function AdminGuard() {
  const { isAuthenticated, user } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return user?.rol === "admin" ? <Outlet /> : <Navigate to="/" replace />;
}
